import { useTranslation } from "react-i18next";

import type { SimpleHeaderProps } from "./SimpleHeader.decl";

export function HeaderSimple({ label }: SimpleHeaderProps) {
  const { t } = useTranslation();

  return <span className="text-xs font-medium">{t(label)}</span>;
}
